import { Geogroup } from '@geovelo-frontends/commons';
import { Box, Skeleton, Typography } from '@mui/material';
import { Link } from 'gatsby';
import React, { Fragment, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

function Breadcrumb({
  dark,
  geogroup,
  items,
}: {
  dark?: boolean;
  geogroup: Geogroup | undefined | null;
  items?: Array<{ label: ReactNode; to?: string }>;
}): JSX.Element {
  const {
    t,
    i18n: { language: currentLanguage },
  } = useTranslation();

  if (geogroup === undefined) {
    return (
      <Box flexShrink={0}>
        <Typography color={dark ? 'inherit' : '#fff'} variant="body2">
          <Skeleton variant="text" width={200} />
        </Typography>
      </Box>
    );
  }

  return (
    <Box flexShrink={0}>
      <Typography color={dark ? 'inherit' : '#fff'} variant="body2">
        <Link
          style={{ color: 'inherit', textDecoration: 'none' }}
          to={`/${currentLanguage}/communities`}
        >
          {t('geovelo.navigation.communities')}
        </Link>
        {items?.map(({ label, to }, index) => (
          <Fragment key={index}>
            {' '}
            /{' '}
            {to ? (
              <Link style={{ color: 'inherit', textDecoration: 'none' }} to={to}>
                {label}
              </Link>
            ) : (
              <span>{label}</span>
            )}
          </Fragment>
        ))}
      </Typography>
    </Box>
  );
}

export default Breadcrumb;
